import { Component,EventEmitter, Output, OnInit, OnChanges, OnDestroy, Input } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { GroupMasterService } from '../../../services/group-master.service';
import { CommonFunction } from '../../../helpers/commonFunction';
import { AlertComponent } from '../../../structure/alert/alert.component';


declare var $: any;
declare var jQuery: any;
declare var autosize: any

@Component({
  selector: 'app-addgroup',
  templateUrl: './add-group.component.html',
  styleUrls: ['./add-group.component.css']
})
export class AddgroupComponent implements OnInit {

  @Output() groupCreated = new EventEmitter();
  createdgroupId :string;

  groupMasterForm: FormGroup;
  groupId: string;
  groupName: string;
  groupTypes: any[];

  constructor(public groupMasterService: GroupMasterService, private commonFunction: CommonFunction, private alert: AlertComponent) { }

  
  getGroupmasterList() {
    this.groupTypes = [];
    this.groupMasterService.getGroupList()
    .subscribe((groupList:any) => {
      if (groupList.status == 0) {
          this.groupTypes = this.commonFunction.sortByKey(groupList.groupList, 'GroupName');
        }
      })
  }

  successOk(message) {
 
    $('#groupDialog').modal('show');
    //  this.onOkFunction = onOK;
  }

  

  addGroup() {
    if (this.groupMasterForm.status == "VALID") {
      var loginUsers = JSON.parse(localStorage.getItem("user"));
      var newGroup = {
        GroupName: this.groupMasterForm.controls.GroupName.value,
        CreatedBy: loginUsers._id
      }

      this.groupMasterService.addGroup(newGroup)
        .subscribe(group => {
          if (group.status == 0) {
            //$('#groupDialog').modal('toggle');
            // this.alert.success(group.message);
            this.alert.success('Tag created successfully.');
            this.groupMasterForm.reset();
            this.getGroupmasterList();
            this.createdgroupId =  group.addGroup._id;
            this.groupCreated.emit(this.createdgroupId);

          } else {
            console.log(group.Group);
            //$('#groupDialog').modal('toggle');
            this.alert.error(group.message);
            // this.alert.error( JSON.stringify(group.err_fields) + ' fields are required or invalid.');
            // this.alert.error(group.message);
            this.groupMasterForm.reset();
            this.createdgroupId =""
            this.groupCreated.emit(this.createdgroupId);
            this.getGroupmasterList();
          }

        });

    } else {
      console.log('Invalid form submit.')
      return false;
    }
  }


  keyDownEnterFunctiongroupAdd(ev) {
    if (ev.keyCode == 13) {
      if (this.groupMasterForm.status == "VALID") {
        var loginUsers = JSON.parse(localStorage.getItem("user"));
        var newGroup = {
          GroupName: this.groupMasterForm.controls.GroupName.value,
          CreatedBy: loginUsers._id
        }
  
        this.groupMasterService.addGroup(newGroup)
          .subscribe(group => {
            if (group.status == 0) {
              $('#groupDialog').modal('toggle');
              // this.alert.success(group.message);
              this.alert.success('Tag created successfully.');
              this.groupMasterForm.reset();
              this.getGroupmasterList();
              this.createdgroupId =  group.addGroup._id;
              this.groupCreated.emit(this.createdgroupId);
  
            } else {
              console.log(group.Group);
              $('#groupDialog').modal('toggle');
              // this.alert.error(group.message);
              this.alert.error(group.message);
              this.groupMasterForm.reset();
              this.createdgroupId =""
              this.groupCreated.emit(this.createdgroupId);
              this.getGroupmasterList();
            }
  
          });
  
      } else {
        console.log('Invalid form submit.')
        return false;
      }
    }
  }

  ngOnInit() {
    this.getGroupmasterList();
    this.groupMasterForm = new FormGroup({
      GroupName: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z0-9][a-zA-Z0-9\-\_\/ ]*[a-zA-Z]+[a-zA-Z0-9\-\_\/ ]*$")
      ]),
    });

    setTimeout(function () {
      $('#groupName').focus();
      $('#groupName').select();
    },500);
    

  }

}
